@if (roleId === roleIds.fluidEngineer) {
<div>
    <div class="container">
        <div class="table-background">
            <div class="project-header">
                <p>{{projectId > 0 ? 'Edit' : 'Add'}} project</p>
                @if (projectId > 0) {
                <a role="button" tabindex="0" (click)="GoToLabList()" (keydown.enter)="GoToLabList()">
                    <span class="em-c-btn__text"> Sample list </span>
                </a>
                }
            </div>
            <hr>
            <div>
                <form class="add-project-form" [formGroup]="addProjectForm">
                    <div class="row">
                        <p>Project information</p>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="em-c-field--small ">
                                <label for="projectNumber" class="em-c-field__label">
                                    Project number
                                    <span class="em-c-field__required">*</span>
                                </label>
                                <div class="em-c-field__body">
                                    <input placeholder="Enter project number"
                                        class="em-c-input em-js-input required-input" formControlName="projectNumber"
                                        id="projectNumber" name="projectNumber" type="text"
                                        (input)="RemoveValidation('projectNumber')" [ngClass]="{
                                            'error-border': invalidFieldIds.has('projectNumber')}" />
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="em-c-field--small ">
                                <label for="projectName" class="em-c-field__label">
                                    Project name</label>
                                <div class="em-c-field__body">
                                    <input placeholder="Enter project name" class="em-c-input em-js-input"
                                        formControlName="projectName" id="projectName" name="projectName" type="text" />
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="em-c-field--small ">
                                <label for="jobNumber" class="em-c-field__label">
                                    Job number</label>
                                <div class="em-c-field__body">
                                    <input placeholder="Enter job number" class="em-c-input em-js-input"
                                        formControlName="jobNumber" id="jobNumber" name="jobNumber" type="text" />
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="em-c-field--small ">
                                <label for="leadEngineer" class="em-c-field__label">
                                    Lead engineer</label>
                                <div class="em-c-field__body">
                                    <input placeholder="Enter lead engineer" class="em-c-input em-js-input"
                                        formControlName="leadEngineer" id="leadEngineer" name="leadEngineer"
                                        type="text" />
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="em-c-field--small ">
                                <label for="buContact" class="em-c-field__label">
                                    BU contact</label>
                                <div class="em-c-field__body">
                                    <input placeholder="Enter BU" class="em-c-input em-js-input"
                                        formControlName="buContact" id="buContact" name="buContact" type="text" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <p>Location information</p>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="em-c-field--small ">
                                <label for="field" class="em-c-field__label">
                                    Field</label>
                                <div class="em-c-field__body">
                                    <input placeholder="Enter Field" class="em-c-input em-js-input"
                                        formControlName="field" id="field" name="field" type="text" />
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="em-c-field--small min-width-18">
                                <label for="country" class="em-c-field__label">
                                    Country <span class="em-c-field__required">*</span></label>
                                <div class="em-c-field__body">
                                    <select class="em-c-select required-input" formControlName="country" id="country"
                                        aria-labelledby="labelSelect" aria-describedby="descSelect"
                                        placeholder="Select Country" (change)="onCountryChange($event)" [ngClass]="{
                                            'error-border': invalidFieldIds.has('country')}">
                                        <option value="" disabled selected>Select Country</option>
                                        @for (country of countries; track $index) {
                                        <option [value]="country">{{country}}</option>
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <label class="em-c-field__label" for="files">Quote</label>
                            <div class="ex-upload">
                                <svg class="em-c-icon em-c-icon--small em-c-field__block-icon upload-icon"
                                    aria-hidden="true">
                                    <use xmlns:xlink="http://www.w3.org/1999/xlink"
                                        xlink:href="images/16/em-icons.svg#upload"></use>
                                </svg>
                                <input class="upload-file em-c-file-upload" aria-labelledby="filesLabel"
                                    aria-describedby="filesDesc" aria-required="false" placeholder="Upload File(s)"
                                    id="files" name="files" type="file" multiple (change)="OnFileChange($event)" />
                                <ul class="em-c-field__list em-js-field-list">
                                    <li class="em-c-field__item">Drag files here</li>
                                    <li class="em-c-field__item em-c-field__item--small">Or click to choose file</li>
                                </ul>
                            </div>
                            <div class="em-c-field__note" id="fileUploadDesc">Upload file(s)</div>
                        </div>
                        @if (fileNames.length > 0) {
                        <div class="after-upload-div">
                            <div class="col">
                                <div class="em-c-field--small ">
                                    <div class="em-c-field__body em-c-input em-js-input file-upload-div ">
                                        <div class="uploaded-file">
                                            <button class="file-list" type="button">
                                                {{ firstFileName }}
                                                <span class="remove-file-icon" role="button" tabindex="0"
                                                    (click)="RemoveFile(0)" (keydown.enter)="RemoveFile(0)"
                                                    (keydown.space)="RemoveFile(0)"
                                                    [attr.aria-label]="'Remove ' + firstFileName">
                                                    <svg class="em-c-icon em-c-icon--small">
                                                        <use xlink:href="images/16/em-icons.svg#x-filled"></use>
                                                    </svg>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            @if (fileNames.length > 1) {
                            <div class="col">
                                <div class="em-c-field--small ml-5">
                                    <label for="fileNames" class="em-c-field__label view-files-label cursor-pointer"
                                        role="button" tabindex="0" (keydown.enter)="ViewFiles()"
                                        (keydown.space)="ViewFiles()" (click)="ViewFiles()">Click to view more
                                        files</label>
                                </div>
                            </div>
                            }
                        </div>
                        }
                    </div>
                    <div class="row">
                        <p>Timeline log</p>
                    </div>
                    <div class="row col-responsive">
                        <div class="col">
                            <div class="em-c-field em-c-field--small ">
                                <label for="kickOffMeetingDate" class="em-c-field__label"> Kick-off meeting</label>
                                <div class="em-c-field__body">
                                    <mat-form-field appearance="outline" class="datepicker">
                                        <input class="em-c-input em-js-input " formControlName="kickOffMeetingDate"
                                            id="kickOffMeetingDate" name="kickOffMeetingDate" [matDatepicker]="picker"
                                            matInput placeholder="MM/DD/YYYY" readonly />
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="em-c-field em-c-field--small ">
                                <label for="sampleReceivedDate" class="em-c-field__label"> Sample received</label>
                                <div class="em-c-field__body">
                                    <mat-form-field appearance="outline" class="datepicker">
                                        <input class="em-c-input em-js-input " formControlName="sampleReceivedDate"
                                            id="sampleReceivedDate" name="sampleReceivedDate" [matDatepicker]="picker1"
                                            matInput placeholder="MM/DD/YYYY" readonly />
                                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                        <mat-datepicker #picker1></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="em-c-field--small ">
                                <label for="restorationStartedDate" class="em-c-field__label">
                                    Restoration started</label>
                                <div class="em-c-field__body ">

                                    <mat-form-field appearance="outline" class="datepicker">
                                        <input class="em-c-input em-js-input " formControlName="restorationStartedDate"
                                            id="restorationStartedDate" name="restorationStartedDate"
                                            [matDatepicker]="picker2" matInput placeholder="MM/DD/YYYY" readonly />
                                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                        <mat-datepicker #picker2></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="em-c-field--small ">
                                <label for="workCompletedDate" class="em-c-field__label">
                                    Work completed</label>
                                <div class="em-c-field__body ">

                                    <mat-form-field appearance="outline" class="datepicker">
                                        <input class="em-c-input em-js-input " formControlName="workCompletedDate"
                                            id="workCompletedDate" name="workCompletedDate" [matDatepicker]="picker3"
                                            matInput placeholder="MM/DD/YYYY" readonly />
                                        <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                                        <mat-datepicker #picker3></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col date-right-spacing">
                            <div class="em-c-field--small ">
                                <label for="reportSubmittedDate" class="em-c-field__label">
                                    Report submitted</label>
                                <div class="em-c-field__body ">

                                    <mat-form-field appearance="outline" class="datepicker">
                                        <input class="em-c-input em-js-input " formControlName="reportSubmittedDate"
                                            id="reportSubmittedDate" name="reportSubmittedDate"
                                            [matDatepicker]="picker4" matInput placeholder="MM/DD/YYYY" readonly />
                                        <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                                        <mat-datepicker #picker4></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <hr>
            <div class="button-div">
                <div class="em-c-btn-group">
                    <button class="em-c-btn em-c-btn--primary em-c-btn--small" (click)="AddProject($event)"
                        [disabled]="!addProjectForm.valid">
                        <span class="em-c-btn__text">{{projectId > 0 ? 'Update' : 'Next'}}</span>
                    </button>
                    <button class="em-c-btn em-c-btn--small em-js-modal-dismiss" (click)="GoToProjectList()">
                        <span class="em-c-btn__text">Cancel</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
}

<ng-template #filesDialog let-dialogRef="dialogRef">
    <div class="em-c-modal " role="alertdialog" aria-modal="true" aria-labelledby="modalTitle"
        aria-describedby="modalDescription">
        <section class="em-c-modal__window">
            <div class="em-c-modal__header " tabindex="0">
                <div>
                    <div class="em-c-modal__title" id="modalTitle">
                        Uploaded Files
                    </div>
                </div>
                <button [mat-dialog-close]="false" class="em-c-btn em-c-btn--bare em-c-modal__close-btn"
                    title="Close modal" aria-label="Button name">
                    <div class="em-c-btn__inner">
                        <svg class="em-c-icon em-c-icon--small  em-c-btn__icon">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink"
                                xlink:href="images/16/em-icons.svg#x-filled"></use>
                        </svg>
                    </div>
                </button>
            </div>
            <div class="em-c-modal__body " id="modalDescription">
                @if (fileNames.length) {
                <ul>
                    @for (name of fileNames; track $index; let index = $index) {
                    <li>{{ name }}
                        <button type="button" class="em-c-btn em-c-btn--bare remove-file-btn"
                            (click)="RemoveFile(index)" [attr.aria-label]="'Remove ' + name">
                            <svg class="em-c-icon em-c-icon--small">
                                <use xlink:href="images/16/em-icons.svg#x-filled"></use>
                            </svg>
                        </button>
                    </li>
                    }
                </ul>
                }
            </div>
        </section>
        <div class="em-c-modal__overlay em-is-closed"></div>
    </div>
</ng-template>

@if (roleId === roleIds.labTech || roleId === roleIds.techResource) {
<div>
    <div class="container">
        <div class="table-background">
            <div class="project-header">
                @if (projectId > 0) {
                <a (click)="GoToLabList()" (keyup.enter)="GoToLabList()" tabindex="0" role="button" class="ml-auto">
                    <span class="em-c-btn__text"> Sample list </span>
                </a>
                }
            </div>
            <hr>
            <div>
                <form class="add-project-form" [formGroup]="addProjectForm">
                    <div class="row">
                        <p>Project information</p>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="em-c-field--small ">
                                <label for="projectNumber" class="em-c-field__label">
                                    Project number <span class="em-c-field__required">*</span></label>
                                <div class="em-c-field__body">
                                    <input class="em-c-input em-js-input" formControlName="projectNumber"
                                        id="projectNumber" name="projectNumber" type="text" readonly />
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="em-c-field--small ">
                                <label for="projectName" class="em-c-field__label">
                                    Project name</label>
                                <div class="em-c-field__body">
                                    <input class="em-c-input em-js-input" formControlName="projectName" id="projectName"
                                        name="projectName" type="text" readonly />
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="em-c-field--small ">
                                <label for="jobNumber" class="em-c-field__label">
                                    Job number</label>
                                <div class="em-c-field__body">
                                    <input class="em-c-input em-js-input" formControlName="jobNumber" id="jobNumber"
                                        name="jobNumber" type="text" readonly />
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="em-c-field--small ">
                                <label for="leadEngineer" class="em-c-field__label">
                                    Lead engineer</label>
                                <div class="em-c-field__body">
                                    <input class="em-c-input em-js-input" formControlName="leadEngineer"
                                        id="leadEngineer" name="leadEngineer" type="text" readonly />
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="em-c-field--small ">
                                <label for="buContact" class="em-c-field__label">
                                    BU contact</label>
                                <div class="em-c-field__body">
                                    <input class="em-c-input em-js-input" formControlName="buContact" id="buContact"
                                        name="buContact" type="text" readonly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <p>Location information</p>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="em-c-field--small ">
                                <label for="field" class="em-c-field__label">
                                    Field</label>
                                <div class="em-c-field__body">
                                    <input class="em-c-input em-js-input" formControlName="field" id="field"
                                        name="field" type="text" readonly />
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="em-c-field--small min-width-18">
                                <label for="country" class="em-c-field__label">
                                    Country</label>
                                <div class="em-c-field__body">
                                    <input class="em-c-input em-js-input" formControlName="country" id="country"
                                        name="country" type="text" readonly />
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="em-c-field--small ">
                                <label class="em-c-field__label" for="files">Quote</label>
                            </div>
                            @if (fileNames.length > 0) {
                            <div class="after-upload-div">
                                <div class="col">
                                    <div class="em-c-field--small ">
                                        <div class="em-c-field__body em-c-input em-js-input file-upload-div ">
                                            <button disabled>{{firstFileName}}</button>
                                        </div>
                                    </div>
                                </div>
                                @if (fileNames.length > 1) {
                                <div class="col">
                                    <div class="em-c-field--small  ml-15">
                                        <span class="em-c-field__label view-files-label cursor-pointer" role="button"
                                            tabindex="0" (keydown.enter)="ViewFiles()" (keydown.space)="ViewFiles()"
                                            (click)="ViewFiles()">Click to
                                            view
                                            more
                                            files</span>
                                    </div>
                                </div>
                                }
                            </div>
                            }
                        </div>
                    </div>
                    <div class="row">
                        <p>Timeline log</p>
                    </div>
                    <div class="row col-responsive">
                        <div class="col">
                            <div class="em-c-field em-c-field--small ">
                                <label for="kickOffMeetingDate" class="em-c-field__label"> Kick-off meeting</label>
                                <div class="em-c-field__body">
                                    <mat-form-field appearance="outline" class="datepicker">
                                        <input class="em-c-input em-js-input " formControlName="kickOffMeetingDate"
                                            id="kickOffMeetingDate" name="kickOffMeetingDate" matInput readonly />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="em-c-field em-c-field--small ">
                                <label for="sampleReceivedDate" class="em-c-field__label"> Sample received</label>
                                <div class="em-c-field__body">
                                    <mat-form-field appearance="outline" class="datepicker">
                                        <input class="em-c-input em-js-input " formControlName="sampleReceivedDate"
                                            id="sampleReceivedDate" name="sampleReceivedDate" matInput readonly />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="em-c-field--small ">
                                <label for="restorationStartedDate" class="em-c-field__label">
                                    Restoration started</label>
                                <div class="em-c-field__body ">
                                    <mat-form-field appearance="outline" class="datepicker">
                                        <input class="em-c-input em-js-input " formControlName="restorationStartedDate"
                                            id="restorationStartedDate" name="restorationStartedDate" matInput
                                            readonly />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="em-c-field--small ">
                                <label for="workCompletedDate" class="em-c-field__label">
                                    Work completed</label>
                                <div class="em-c-field__body ">
                                    <mat-form-field appearance="outline" class="datepicker">
                                        <input class="em-c-input em-js-input " formControlName="workCompletedDate"
                                            id="workCompletedDate" name="workCompletedDate" matInput
                                            readonly />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col date-right-spacing">
                            <div class="em-c-field--small ">
                                <label for="reportSubmittedDate" class="em-c-field__label">
                                    Report submitted</label>
                                <div class="em-c-field__body ">
                                    <mat-form-field appearance="outline" class="datepicker">
                                        <input class="em-c-input em-js-input " formControlName="reportSubmittedDate"
                                            id="reportSubmittedDate" name="reportSubmittedDate" matInput readonly />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <hr>
            <div class="button-div">
                <div class="em-c-btn-group">
                    <button class="em-c-btn em-c-btn--small em-js-modal-dismiss" (click)="GoToProjectList()">
                        <span class="em-c-btn__text">Cancel</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
}